import L from 'leaflet';
import qs from 'qs';

export const GeoJSONLayer = L.GeoJSON.extend({
  // Store each FeatureCollection's layer by key
  _keyLayers: {},

  initialize(options) {
    L.setOptions(this, options);
    L.FeatureGroup.prototype.initialize.call(this, null);
    this.fetchDataBound = this.fetchData.bind(this);
  },

  onAdd(map) {
    this._map = map;
    // Start listening for changes in the map boundaries, and trigger parcel fetch on any change.
    map.on('dragend', this.fetchDataBound);
    map.on('zoomend', this.fetchDataBound);
    map.on('viewreset', this.fetchDataBound);
    // Connect to url and fetch the parcels with Oboe.
    this._reset();
    this.fetchDataBound();
  },

  onRemove(map) {
    map.off('dragend', this.fetchDataBound);
    map.off('zoomend', this.fetchDataBound);
    map.off('viewreset', this.fetchDataBound);
  },

  fetchData() {
    let ajaxStart = new CustomEvent('ajaxStart');
    window.dispatchEvent(ajaxStart);

    let { _northEast: ne, _southWest: sw } = this._map.getBounds();
    fetch(this.options.url + '?' + qs.stringify({ ne, sw }))
      .then(res => res.json())
      .then(res => {
        if (res.features) {
          res.features.forEach(f => {
            // Gradually render the received parcels.
            if (f.id && !(f.id in this._keyLayers)) {
              this._keyLayers[f.id] = f;
              this.addData(f);
            }
          });
        }
        return res;
      })
      .then(results => {
        let ajaxEnd = new CustomEvent('ajaxEnd', { detail: { results } });
        window.dispatchEvent(ajaxEnd);
      });
  },

  _reset() {
    this.clearLayers();
    this._keyLayers = {};
  },
});

export default o => new GeoJSONLayer(o);
